// Detect audio MIME type from base64 prefix bytes.
// data:audio/* wildcards don't work in data URIs — browsers need a specific MIME type.
export const getAudioMimeFromBase64 = (b64) => {
  if (!b64 || b64.length < 8) return 'audio/mpeg'; // fallback
  if (b64.startsWith('SUQz') || b64.startsWith('//')) return 'audio/mpeg';   // ID3 tag or MP3 sync
  if (b64.startsWith('T2dnUw')) return 'audio/ogg';                           // OggS
  if (b64.startsWith('Zkxh')) return 'audio/flac';                            // fLaC
  if (b64.startsWith('UklGR')) return 'audio/wav';                            // RIFF (WAV)
  if (b64.startsWith('AAAAIG') || b64.startsWith('AAAAHG') ||
      b64.startsWith('AAAAKG')) return 'audio/mp4';                           // ftyp M4A
  return 'audio/mpeg'; // default fallback
};
